    import React from 'react';
    import { Container, Row, Col } from 'react-bootstrap';
    import { useTranslation } from 'react-i18next';
    import i1 from './assets/Concorso_Isola_di_Capri.jpeg';
    import i2 from './assets/Caterina_Vivarelli_Concerto.png';

    const Curriculum = () => {
    const { t } = useTranslation();

    return (
        <Container className='my-5'>
        <Row className='d-flex flex-column-reverse flex-md-row'>
            <Col xs={12} md={4} className="mb-4 mb-md-0 px-5">
            {/* Image column */}
            <hr className='d-md-none'></hr>
            <img src={i1} alt="Image 1" className="img-fluid w-100 mb-4 mt-4 mt-md-0 d-block mx-auto" />
            <img src={i2} alt="Image 2" className="img-fluid w-100 d-block mx-auto" />
            {/* Add more images here */}
            </Col>
            <Col xs={12} md={8}>
            {/* Content column */}
            <p dangerouslySetInnerHTML={{ __html: t('bio.section1') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section2') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section3') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section4') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section5') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section6') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section7') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section8') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section9') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section10') }}></p>
            <p dangerouslySetInnerHTML={{ __html: t('bio.section11') }}></p>
            </Col>
        </Row>
        </Container>
    );
    };

    export default Curriculum;